import type { components, operations } from "./api";

export type CreateBackupRequest = components["schemas"]["CreateBackupDto"];
export type RestoreBackupRequest = components["schemas"]["RestoreBackupDto"];
export type BackupType = CreateBackupRequest["type"];

export type ListBackupsQuery = NonNullable<
  operations["BackupsController_list"]["parameters"]["query"]
>;

export interface Backup {
  id: string;
  type: BackupType;
  status: string;
  filePath?: string;
  sizeBytes?: number;
  triggeredBy: string;
  completedAt?: string;
  notes?: string;
  createdAt: string;
  updatedAt: string;
}

export interface BackupSchedule {
  enabled: boolean;
  cron: string;
  timezone?: string;
  lastRunAt?: string;
}

/** Backup scopes offered in the create dialog (mirrors the backend TYPES whitelist). */
export const BACKUP_TYPES = ["FULL", "CONTENT", "DATABASE"] as const;

export const BACKUP_TYPE_LABELS: Record<(typeof BACKUP_TYPES)[number], string> = {
  FULL: "نسخة كاملة",
  CONTENT: "المحتوى والوسائط فقط",
  DATABASE: "قاعدة البيانات فقط",
};

export const BACKUP_STATUS_LABELS: Record<string, string> = {
  pending: "قيد الانتظار",
  running: "قيد التنفيذ",
  completed: "مكتمل",
  failed: "فشل",
};
